import React from 'react';
import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import _ from 'lodash';
import {inject} from 'mobx-react';
import {observe} from 'mobx';
import HttpClient from 'services/HttpClient';
import {CREATE_CATEGORY_TYPE, EDIT_CATEGORY_TYPE, CATEGORY_CONSTRAINS} from 'constants/adminPupups';
import validate from 'validate.js';

const CATEGORY_REQUEST = '/api/v1/categories/';
@inject('editableCategoryStore')
@inject('createCourseStore')
@inject('categoryStore')
@inject('alertStore')
export default class EditCategoryPopup extends React.Component {

  state = {
    isNew: true,
    open: false,
    formData: {},
    errors: {}
  };

  handleChange = (e) => {
    let newState = _.assign({}, this.state.formData, {[e.target.name]: e.target.value});
    this.setState({formData: newState});
  };

  componentWillMount() {
    this.listener = observe(this.props.editableCategoryStore, 'type', () => {
      if(this.props.editableCategoryStore.type.valueOf() === CREATE_CATEGORY_TYPE ||
      this.props.editableCategoryStore.type.valueOf() === EDIT_CATEGORY_TYPE) {
        const id = this.props.editableCategoryStore.object_id;
        const category = this.props.categoryStore.getCategoryById(id);
        if (!category) {
          this.setState({open: true, formData: {title: '', friendly_id_url: ''}, isNew: true, errors: {}})
        }
        else {
          const {title, friendly_id_url} = category;
          this.setState({open: true, formData: {title: title, friendly_id_url: friendly_id_url, id: id}, isNew: false, errors: {}})
        }
      }
    })
  }

  componentWillUnmount() {
    this.listener();
  }

  handleOpen = () => {
    this.setState({open: true});
  };

  getHeader = () => {
    return this.state.isNew ? 'New Category' : 'Edit Category'
  };

  handleClose = () => {
    this.setState({open: false, formData: {}});
  };

  handleSave = e => {
    e.preventDefault();
    const errors = validate(this.state.formData, CATEGORY_CONSTRAINS, {fullMessages: false });
    this.setState({errors: errors || {}});
    if(!errors)
      this.state.isNew ? this.handleCreate() : this.handleUpdate();
  };

  getSaveButtonName = () => {
    return this.state.isNew ? 'Create' : 'Save'
  };


  handleUpdate = () => {
    const {formData} = this.state;
    const {course} = this.props.createCourseStore;
    const category = {
      ...formData,
      course_id: course.id
    };
    new HttpClient().put(CATEGORY_REQUEST + this.state.formData.id,
      {category}).then((data) => {
      this.props.alertStore.success('Successfully updated');
      this.props.categoryStore.handleUpdateCategory(data.body.data.category);
      this.handleClose();
    }).catch(() => {
     this.handleError()
    })
  };

  handleCreate = () => {
    const {formData} = this.state;
    const {course} = this.props.createCourseStore;
    const category = {
      ...formData,
      course_id: course.id
    };
    new HttpClient().post(CATEGORY_REQUEST,
      {category}).then((data) => {
      this.props.alertStore.success('Successfully created');
      this.props.categoryStore.createCategory(data.body.data.category);
      this.handleClose();
    }).catch((e) => {
      this.handleError(e.body.data.errors)
    })
  };

  handleError = (errors) => {
    let newState = {};
    if(_.has(errors, 'title'))
      newState = _.assign({}, {title: ['Title has already been taken']});
    if(_.has(errors, 'friendly_id_url'))
      newState= _.assign({}, newState, {friendly_id_url: ['Title has already been taken']});
    this.setState({errors: newState});
    this.props.alertStore.success('Category invalid')

  };

  render() {
    return (
      <div>
        {/*<button className="edit-category-btn ic ic-edit" onClick={this.handleOpen} type="button">*/}
        {/*</button>*/}
        <Dialog
          className="modal-wrapper"
          title={this.getHeader()}
          modal={true}
          open={this.state.open}
        >
          <form className="create-category form-modal">
            <div className="input-wrap main">
              <TextField
                onChange={this.handleChange}
                className='category-name'
                name="title"
                value={this.state.formData.title || ''}
                floatingLabelText="Category Title"
                errorText={this.state.errors.title}
                type="text"
              />
              <TextField
                onChange={this.handleChange}
                className='friendly-url'
                name="friendly_id_url"
                value={this.state.formData.friendly_id_url || ''}
                errorText={this.state.errors.friendly_id_url}
                floatingLabelText="Friednly URL(OPTIONAL)"
                type="text"
              />
            </div>
            <div className="button-set">
              <button className="btn gray small transparanted cancel-btn" type="button"
                      onClick={this.handleClose}>Cancel
              </button>
              <button className="btn gray small transparanted create-btn" type="submit"
                      onClick={this.handleSave}>{this.getSaveButtonName()}
              </button>
            </div>
          </form>
        </Dialog>
      </div>)

  }
}



// WEBPACK FOOTER //
// ./src/modules/categories/components/EditCategoryPopup.js